/*
 * lw-card-dots.js — VEVOR-style card image interactions (Tony 2026-08-07).
 * One row of dots per card (one per product image, capped at 5). Behaviour:
 *   - hover the card      -> show the 2nd image (dot 2 active)
 *   - hover a dot         -> show that image
 *   - leave the card      -> back to the 1st image (dot 1 active)
 * Everything drives the single main <img>'s src (the 2nd Dawn image is hidden
 * via CSS), so the dots always reflect what is shown. Document-level delegation
 * survives the facets AJAX re-render of #product-grid; a guard keeps it
 * single-init even though the loader tag is emitted on more than one render.
 */
(function () {
  if (window.__lwCardDots) return;
  window.__lwCardDots = true;

  function dots(card) { return card.querySelectorAll('.lw-card-dot'); }

  function show(card, dot) {
    if (!card || !dot) return;
    var img = card.querySelector('.card__media .media img');
    var src = dot.getAttribute('data-src');
    if (!img || !src) return;
    // srcset/sizes would otherwise win over src on the responsive image
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    if (img.getAttribute('src') !== src) img.setAttribute('src', src);
    var ds = dots(card);
    for (var i = 0; i < ds.length; i++) ds[i].classList.toggle('is-active', ds[i] === dot);
  }

  document.addEventListener('mouseover', function (e) {
    if (!e.target.closest) return;
    var card = e.target.closest('.card-wrapper');
    if (!card || !card.querySelector('.lw-card-dots')) return;
    var dot = e.target.closest('.lw-card-dot');
    if (dot) { show(card, dot); return; }
    if (!card.__lwOn) {
      card.__lwOn = true;
      var ds = dots(card);
      // preload every frame so the swaps are instant / no flash
      for (var i = 0; i < ds.length; i++) {
        var s = ds[i].getAttribute('data-src');
        if (s) { var pre = new Image(); pre.src = s; }
      }
      if (ds.length > 1) show(card, ds[1]); // reveal the 2nd image on card hover
    }
  });

  document.addEventListener('mouseout', function (e) {
    if (!e.target.closest) return;
    var card = e.target.closest('.card-wrapper');
    if (!card) return;
    var to = e.relatedTarget;
    if (to && card.contains(to)) return; // still inside the same card
    card.__lwOn = false;
    var ds = dots(card);
    if (ds.length) show(card, ds[0]); // back to the 1st image
  });

  document.addEventListener('click', function (e) {
    var dot = e.target.closest && e.target.closest('.lw-card-dot');
    if (!dot) return;
    e.preventDefault();
    e.stopPropagation();
    show(dot.closest('.card-wrapper'), dot);
  });
})();
